import React from "react";
import { CirclePoint } from "../style";
import { OptionImage } from "../../product/style";

const ColorOverrides = ({ colorOverrides }) => {
  if (!colorOverrides || !colorOverrides.length) {
    return null;
  }

  return (
    <div className="px-1 pt-1" style={{ width: "max-content" }}>
      {colorOverrides.map((colorOverride, index) => {
        if (!colorOverride.selectedOption) return null;

        return (
          <div key={index} className="d-flex align-items-center gap-2 pb-2">
            <strong style={{ textTransform: "capitalize" }}>
              {colorOverride.propertyName}
            </strong>

            <CirclePoint />
            <div className="d-inline-flex align-items-center gap-2 text-muted">
              {colorOverride.selectedOption.image && (
                <OptionImage
                  src={colorOverride.selectedOption.image}
                  alt={colorOverride.selectedOption.short_name || colorOverride.selectedOption.name}
                  className="border border-dark rounded-circle me-1"
                />
              )}
              {(colorOverride.selectedOption.short_name && colorOverride.selectedOption.short_name.trim()) 
                ? colorOverride.selectedOption.short_name 
                : colorOverride.selectedOption.name}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ColorOverrides;

